// import Utils from "../core/utils";
import { device } from "~/shared/tools/device";
import { SubmitBtn } from "../components/submitFormButton/SubmitBtn.component";
import { TYPE_4_OPTIONS, FIELD_SIZE, FIELD_RADIUS, FORM_STYLE } from "~/shared/configs/qform-options";
import { JSEncrypt } from "jsencrypt";
import { reachVkGoal } from "../core/vkPixel.js";
import { v1 } from "uuid";
import { cookie } from "../../shared/tools/cookie";
import Restrictions from "~/modules/components/Restrictions";
import { setVoteResult } from "~/modules/components/ResultsVoteAfterSendForm";
import { COMPONENTS } from "~/shared/constants/ComponentList";
export class Form {
  /**
   * Конструктор класса для создания объекта.
   * @param {HTMLDivElement} node - Селектор, с которым будет связан объект.
   * @param {FormSettings} settings - Настройки формы.
   */
  constructor(node, settings) {
    this.selector = node;
    this.TYPE_COMPONENTS = {};
    this.components = [];
    this.data = settings.data;
    this.allStyle = settings.data.style || null;
    this.allOptions = settings.data.options || null;
    this.agreementSettings = settings.data.agreement || null;
    this.isAdviseCheckboxChecked = 0;
    this.id = settings.data.formID;
    this.blockId = settings.data.firstBlockId;
    this.mode = settings.options.mode;
    this.domain = settings.options.domain;
    this.settings = settings;
    this.options = {
      ...settings.options,
      ...this.settings
    };
    this.options.uploadActive = settings.data.uploadActive;
    // this.options.formStyle = settings.data.formStyle || false;
    /**
     * @type {{ [key: string]: string }}*/
    this.messages = settings.data.messages || null;
    this.btnModalComponent = null;
    // ?????
    this.options.openButton = settings.data.openButton || false;
    this.options.buttonText = settings.data.buttonText || false;
    this.options.buttonHoverStyle = settings.data.buttonHoverStyle || 0;
    // this.options.formStyle.labelsPosition = 2
    /* this.options.fieldAlign =
      this.options.formStyle && FIELD_ALIGN[this.options.formStyle.fieldAlign]
        ? FIELD_ALIGN[this.options.formStyle.fieldAlign]
        : false; */
    this.publicKey = settings.options.publicKey;
    this.options.formId = settings.data.formID;
    this.options.agreementLabelEx = settings.data.labelEx || "";
    this.useRecaptcha = settings.data.useRecaptcha;
    this.useDesign = settings.data.useDesign;
    this.captchaSitekey = settings.data.captchaSitekey;
    this.recaptchaVersion = settings.data.recaptchaVersion;
    this.recaptchaMode = settings.data.recaptchaMode;
    // this.options.agreement = settings.data.agreement;

    this.fields = settings.data.fields;
    this.formStyle = settings.data.useDesign === 1;
    this.fontCssRule = null;
    this.rows = [];
    this.formWidth = settings.data.width;
    /* this.getStyle(); */
    /* if (this.formStyle) {
      this.getStyle();
    } */

    /* this.Emitter = new Emitter(); */

    this.startTime = new Date().getTime();
    //время начала заполнения формы
    this.startTimeFilling = null;
    this.emitterGlob = settings.emitterGlob;
    this.emitterStatistics = settings.emitterStatistics;
    this.emitterStatistics.emit(`${this.id}:timesTamp`, {
      id: this.id
    });
    this.emitterStatistics.emit(`${this.id}:uid`, {
      id: this.id,
      uid: settings.data.uid
    });
    this.emitterStatistics.emit(`${this.id}:siteId`, {
      id: this.id,
      site_id: settings.data.siteId
    });
    this.emitterFormWidget = settings.emitterFormWidget;
    this.Proxy = settings.options.proxy_module;
    this.countInitComponents = 0; // Счетчик инициализированых компонентов
    this.device = settings.device;
    //настройки картинки для квиза
    this.formPictureSrc = settings.data.img_src;
    this.formPicturePosition = settings.data.img_position;
    this.formPictureShowOnMobile = settings.data.img_show_on_mobile;
    this.widgetId = settings.data.videowidgetId;
    const userUUID = `${settings.data.formID}_uiid`;
    if (!!cookie.get(userUUID)) {
      this.uuID = cookie.get(userUUID);
    } else {
      this.uuID = v1();
      cookie.set(userUUID, this.uuID);
    }
  }
  async getRoot() {
    let styleForm = ["qform", "qform-default", "qform-size-md", "qform-placeholder_show", "qform-radius-5px", "qform-label_inside_show", "qform-icon_inside_left", "qform-hint_outside-left", "qform-valid_light", "qform-error_light"];

    // отрисовка кнопки "далее"
    this.$submitBtn = this.$.create("div", "qform-row");
    this.submitBtn = new SubmitBtn(this.$submitBtn, {
      tabNum: 0,
      formIndex: this.options.formIndex,
      formId: this.options.formId,
      Emitter: this.Emitter,
      useDesign: this.useDesign,
      submitSetting: this.data.submitButton,
      mode: this.mode,
      messages: this.messages,
      showCaption: this.data.showCaption,
      captionLink: this.data.linkCreate,
      disabledClass: this.data.style.formStyleSubmitButton.inactive,
      languageId: this.data.languageId
    });
    this.submitBtn.toHTML();
    this.submitBtn.init({
      disable: !this.settings.data.active
    });
    this.submitBtn.setHoverClass(this.allStyle);
    this.$form = this.$.create("form", styleForm);
    this.components = this.components.map(x => {
      let $el;
      let isNewRow;
      if (x.options.row) {
        if (!this.rows.find(row => row.id === x.options.row)) {
          const newRow = {
            id: x.options.row,
            $el: this.$.create("div", "qform-row"),
            elementsCount: 1
          };
          this.rows.push(newRow);
          $el = newRow.$el;
          isNewRow = true;
        } else {
          const row = this.rows.find(row => row.id === x.options.row);
          $el = row.$el;
          row.elementsCount++;
          isNewRow = false;
        }
      } else {
        $el = this.$.create("div", "qform-row");
        isNewRow = true;
        this.rows.push({
          id: `single_row_${this.rows.length}`,
          $el
        });
      }
      x.Component = new x.Component($el, x.options, this.selector.getAttribute("data-q-form-index")); // x.Component.then(component => {return new component($el, x.options)})//  new x.Component($el, x.options);
      const component = x.Component;
      $el.$el.insertAdjacentHTML("beforeend", component.toHTML());
      if (isNewRow) {
        this.$form.append($el);
      }
      return component;
    });
    this.$form.append(this.$submitBtn);
    switch (this.data.displayType) {
      case 1:
        return this.createModal(this.$form);
      case 0:
      default:
        return this.$form;
    }
  }
  addFormPicture() {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$el.$el;
    const imgPositions = ["right", "left", "top", "bottom", "background"];
    const img_position = imgPositions[this.formPicturePosition - 1];
    if (img_position !== "background") {
      this.$picture = this.$.create("div", ["is_qform-picture-container"]);
      el.classList.add("qform__form-with-picture", `qform__form-picture-${img_position}`);
      this.$picture.$el.style["background-image"] = `url(${this.formPictureSrc})`;
      el.prepend(this.$picture.$el);
    } else {
      //если форма не в модальном окне
      if (this.data.displayType !== 1) {
        el.classList.add("qform__form-with-bg-picture");
        el.style["background-image"] = `url(${this.formPictureSrc})`;
      }
      //иначе добалвение фона происходит в setStyle()
    }
  }
  setFormPictureHeight() {
    const imgPositions = ["right", "left", "top", "bottom", "background"];
    const img_position = imgPositions[this.formPicturePosition - 1];
    if (img_position !== "background") {
      if (img_position === "left" || img_position === "right") {
        if (window.innerWidth < 425) {
          if (this.$picture) {
            //устанавливаем высоту, равную высоте формы (ограничена 50vh)
            this.$picture.$el.style.height = this.$form.$el.clientHeight + "px";
          }
        }
      } else {
        if (this.$picture) {
          //устанавливаем высоту, равную высоте формы (ограничена 50vh)
          this.$picture.$el.style.height = this.$form.$el.clientHeight + "px";
        }
      }
    }
  }
  createModal($form) {
    const $root = this.$.create("div");
    const $overlay = this.$.create("div", ["form-overlay", "hidden"]);
    const $modal = this.$.create("div", ["form-modal", `qform-theme-${this.allStyle.formStyleCommon.theme ? "black" : "white"}`]);
    this.$modal = $modal;
    if (this.formWidth > 0) {
      $modal.$el.classList.add("qform_modal-adaptive");
    }
    $overlay.id(`modal_${this.options.formId}_${this.options.formIndex}`);
    $modal.append(this.getModalCloseBtn());
    (this.settings.data.hasTimeLimit || this.settings.data.hasAmountLimit) && $modal.append(Restrictions.getRestrictionsFormWrapper(this.settings.data));
    $modal.append($form);
    $overlay.append($modal);
    //записываем элемент формы в модальном окне для простоты доступа для изменения ширины формы
    this.$modalForm = $form;
    this.$btnModal = this.$.create("div", "btn_modal-box");
    this.$btnModal.id(`btn_modal-box_${this.options.formId}_${this.options.formIndex}`);
    this.btnModalComponent = new this.BtnModalComponent(this.$btnModal, {
      Emitter: this.Emitter,
      formPicturePosition: this.formPicturePosition,
      formType: "form",
      ...this.options
    });
    this.$btnModal.html(this.btnModalComponent.toHTML());
    $root.append(this.$btnModal);
    this.Emitter.subscribe("openModal", () => {
      if (this.widgetId) {
        try {
          if (!window.players[this.widgetId].isDisposed()) {
            window.players[this.widgetId].dispose();
          }
        } catch (e) {

        } finally {
          this.showWidget();
        }
      }
    });
    this.Emitter.subscribe("closeModal", () => {
      const $widgetsWrapper = document.querySelector(".qform__freewidgets-wrapper");
      $widgetsWrapper?.classList.remove("qform__high-zindex");
      if (this.widgetId) {
        if (!window.players[this.widgetId].isDisposed()) {
          window.players[this.widgetId].dispose();
          document.querySelector(`.qform__freewidgets-wrapper [data-widget=${this.widgetId}]`)?.remove();
        }
      }
    });
    $root.append($overlay);
    //добавляем изображение к форме, если необходимо
    if (this.formPictureSrc) {
      this.addFormPicture($modal.$el);
    }
    return $root;
  }
  getModalCloseBtn() {
    const $btnClose = this.$.create("div", ["form-modal__close-btn"]);
    $btnClose.id(`modal_${this.options.formId}_${this.options.formIndex}_btn-close`);
    return $btnClose;
  }
  async getComponent() {
    this.arrComponentsOptions = [];
    this.fields.forEach((field, index) => {
      if (TYPE_4_OPTIONS[field.typeId]) {
        this.arrComponentsOptions.push({
          id: field.id,
          typeId: field.typeId
        });
      }
      if (this.TYPE_COMPONENTS[field.typeId]) {
        this.components.push({
          Component: this.TYPE_COMPONENTS[field.typeId],
          options: {
            ...field,
            Emitter: this.Emitter,
            ...this.options,
            allStyle: this.allStyle,
            useDesign: this.useDesign,
            formWidth: this.formWidth,
            formDisplayType: this.data.displayType,
            messages: this.messages
          }
        });
        if (index === this.fields.length - 1) {
          if (this.useRecaptcha) {
            // добавляю CaptchaComponent
            this.components.push({
              Component: this.TYPE_COMPONENTS.CaptchaComponent,
              // CaptchaComponent,
              options: {
                formIndex: this.options.formIndex,
                formId: this.options.formId,
                messages: this.messages,
                captchaSitekey: this.captchaSitekey,
                recaptchaVersion: this.recaptchaVersion || 2,
                recaptchaMode: this.recaptchaMode || 0,
                Emitter: this.Emitter
              }
            });
          }
          // добавляю AgreementComponent
          this.components.push({
            Component: this.TYPE_COMPONENTS.AgreementComponent,
            // AgreementComponent,
            options: {
              formIndex: this.options.formIndex,
              formId: this.options.formId,
              messages: this.messages,
              agreementLabelEx: this.options.agreementLabelEx,
              submitSetting: this.data.submitButton,
              captchaSitekey: this.captchaSitekey,
              mode: this.mode,
              domain: this.options.domain,
              recaptchaVersion: this.recaptchaVersion || 2,
              recaptchaMode: this.recaptchaMode || 0,
              server_host: this.options.server_host,
              agreement_controller: this.options.agreement_controller,
              agreementSettings: this.agreementSettings,
              Emitter: this.Emitter,
              useDesign: this.useDesign,
              formWidth: this.formWidth,
              styles: this.allStyle,
              device: this.device,
              showCaption: this.data.showCaption,
              captionLink: this.data.linkCreate
            }
          });
        }
      }
    });
    // this.getOptions(this.arrComponentsOptions);
  }
  getStyle() {
    if (!this.allStyle) {
      this.Transporter.post(`https://${this.options.server_host}${this.options.style_controller}`, {
        body: {
          formId: this.id
        },
        options: {
          method: "POST",
          decode: false
        },
        callback: this.setStyle = this.setStyle.bind(this)
      });
    } else {
      this.setStyle(this.allStyle);
    }
  }
  setStyle(data) {
    this.components.forEach(component => {
      if (component.setClassField && data) {
        component.setClassField(data);
      }
    });
    this.rows.forEach((row, i) => {
      //устанавливаем уникальный идентификатор для возможности стилизации отдельной строки
      row.$el.$el.id = `qform-row_${this.id}_${i + 1}`;
      if (row.elementsCount > 1) {
        const root = row.$el.$el;
        root.classList.add(`multiple-cols-${row.elementsCount}`);
        for (let i = 0; i < root.children.length; i++) {
          root.children[i].classList.add("multiple-col");
        }
      }
    });
    if (this.btnModalComponent && this.btnModalComponent.setClassField && data) {
      this.btnModalComponent.setClassField(data);
    }
    if (data) {
      this.$form.$el.setAttribute("class", "qform");
    }
    if (data.formStyleCommon.useDesign) {
      // Стиль формы
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldStyle !== "undefined" && FORM_STYLE[data.formStyleCommon.fieldStyle]) {
        this.$form.$el.classList.add(FORM_STYLE[data.formStyleCommon.fieldStyle]);
      }
      // Темная тема формы
      if (data.formStyleCommon && data.formStyleCommon.theme) {
        this.$form.$el.classList.add("qform-theme-black");
      }
      // Состояние полей
      // if (typeof data.formStyleFieldState !== "undefined") {
      //   let color = {
      //     0: "grey",
      //     1: "blue",
      //     2: "dark-blue",
      //     3: "black",
      //   };
      //   if (data.formStyleFieldState.changeColorOnHover) {
      //     this.$form.$el.classList.add(
      //       `qform-hover_${color[data.formStyleFieldState.colorOnHover]}`
      //     );
      //   } else {
      //     //оставляем дефолтный класс поля при наведении
      //     this.$form.$el.classList.add(`qform-hover_grey`);
      //   }

      //   if (data.formStyleFieldState.changeColorOnFocus) {
      //     this.$form.$el.classList.add(
      //       `qform-focus_${color[data.formStyleFieldState.colorOnFocus]}`
      //     );
      //   } else {
      //     //оставляем дефолтный класс поля при фокусе
      //     this.$form.$el.classList.add(`qform-focus_grey`);
      //   }

      //   if (!data.formStyleFieldState.useDesign) {
      //     this.$form.$el.classList.remove("qform-hover_grey");
      //     this.$form.$el.classList.remove("qform-hover_blue");
      //     this.$form.$el.classList.remove("qform-hover_dark-blue");
      //     this.$form.$el.classList.remove("qform-hover_black");

      //     this.$form.$el.classList.remove("qform-focus_grey");
      //     this.$form.$el.classList.remove("qform-focus_blue");
      //     this.$form.$el.classList.remove("qform-focus_dark-blue");
      //     this.$form.$el.classList.remove("qform-focus_black");
      //   }
      // }
      // Размер полей
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldSize !== "undefined" && FIELD_SIZE[data.formStyleCommon.fieldSize]) {
        this.$form.$el.classList.add(FIELD_SIZE[data.formStyleCommon.fieldSize]);
      }
      // Border-radius полей
      if (data.formStyleCommon && typeof data.formStyleCommon.fieldRounding !== "undefined" && FIELD_RADIUS[data.formStyleCommon.fieldRounding]) {
        this.$form.$el.classList.add(FIELD_RADIUS[data.formStyleCommon.fieldRounding]);
      }
      // label
      if (data.formStyleLabel && typeof data.formStyleLabel.type !== "undefined") {
        if (data.formStyleLabel.type === 0) {
          if (typeof data.formStyleLabel.labelOutsidePosition !== "undefined" && data.formStyleLabel.labelOutsidePosition === 0) {
            this.$form.$el.classList.add("qform-label_outside_top");
          } else {
            this.$form.$el.classList.add("qform-label_outside_left");
          }
        } else {
          if (typeof data.formStyleLabel.labelInsideShowOnEnter !== "undefined" && data.formStyleLabel.labelInsideShowOnEnter === 0) {
            this.$form.$el.classList.add("qform-label_inside_hide");
          } else {
            this.$form.$el.classList.add("qform-label_inside_show");
          }
        }
        if (!data.formStyleLabel.useDesign) {
          this.$form.$el.classList.remove("qform-label_outside_top");
          this.$form.$el.classList.remove("qform-label_outside_left");
          this.$form.$el.classList.remove("qform-label_inside_hide");
          this.$form.$el.classList.remove("qform-label_inside_show");
        }
      }
      if (data.formStyleLabel && !data.formStyleLabel.placeholderShow) {
        this.$form.$el.classList.add("qform-placeholder_hide");
      }
      // Icon
      if (data.formStyleIcon && typeof data.formStyleIcon.position !== "undefined") {
        if (data.formStyleIcon.position === 0) {
          if (typeof data.formStyleIcon.positionInside !== "undefined" && data.formStyleIcon.positionInside === 0) {
            this.$form.$el.classList.add("qform-icon_inside_left");
          } else {
            this.$form.$el.classList.add("qform-icon_inside_right");
          }
        } else {
          if (typeof data.formStyleIcon.positionOutside !== "undefined" && data.formStyleIcon.positionOutside === 0) {
            this.$form.$el.classList.add("qform-icon_outside_left");
          } else {
            this.$form.$el.classList.add("qform-icon_outside_right");
          }
        }
        if (!data.formStyleIcon.useDesign) {
          this.$form.$el.classList.remove("qform-icon_inside_left");
          this.$form.$el.classList.remove("qform-icon_inside_right");
          this.$form.$el.classList.remove("qform-icon_outside_left");
          this.$form.$el.classList.remove("qform-icon_outside_right");
        }
      }
      // Hint
      if (data.formStyleHelp && typeof data.formStyleHelp.position !== "undefined") {
        if (data.formStyleHelp.position === 0) {
          this.$form.$el.classList.add("qform-hint_label");
        } else if (data.formStyleHelp.position === 1) {
          this.$form.$el.classList.add("qform-hint_inside-left");
        } else if (data.formStyleHelp.position === 2) {
          this.$form.$el.classList.add("qform-hint_inside-right");
        } else if (data.formStyleHelp.position === 3) {
          this.$form.$el.classList.add("qform-hint_outside-left");
        } else if (data.formStyleHelp.position === 4) {
          this.$form.$el.classList.add("qform-hint_outside-right");
        } else if (data.formStyleHelp.position === 5) {
          this.$form.$el.classList.add("qform-hint_bottom");
        }
        if (!data.formStyleHelp.useDesign) {
          this.$form.$el.classList.remove("qform-hint_label");
          this.$form.$el.classList.remove("qform-hint_inside-left");
          this.$form.$el.classList.remove("qform-hint_inside-right");
          this.$form.$el.classList.remove("qform-hint_outside-left");
          this.$form.$el.classList.remove("qform-hint_outside-right");
          this.$form.$el.classList.remove("qform-hint_bottom");
        }
        this.setHintStyles();
      }

      //если форма в модальном окне и картинка для формы должна быть фоном
      if (this.data.displayType === 1 && this.formPicturePosition === 5) {
        //фон добавляется к модальному окну
        this.$modalForm.$el.style.backgroundColor = "transparent";
        this.$modal.$el.classList.add("qform__form-with-bg-picture");
        this.$modal.$el.style["background-image"] = `url(${this.formPictureSrc})`;
      }

      // Valid
      if (data.formStyleValidationSuccess && typeof data.formStyleValidationSuccess.type !== "undefined") {
        if (data.formStyleValidationSuccess.type === 0) {
          if (typeof data.formStyleValidationSuccess.iconAsideLabelPosition !== "undefined" && data.formStyleValidationSuccess.iconAsideLabelPosition === 0) {
            this.$form.$el.classList.add("qform-valid_inside-left");
          } else {
            this.$form.$el.classList.add("qform-valid_inside-right");
          }
        } else if (data.formStyleValidationSuccess.type === 1) {
          if (typeof data.formStyleValidationSuccess.iconOutsideInputPosition !== "undefined" && data.formStyleValidationSuccess.iconOutsideInputPosition === 0) {
            this.$form.$el.classList.add("qform-valid_outside-left");
          } else {
            this.$form.$el.classList.add("qform-valid_outside-right");
          }
        } else if (data.formStyleValidationSuccess.type === 2) {
          this.$form.$el.classList.add("qform-valid_label");
        } else if (data.formStyleValidationSuccess.type === 3) {
          this.$form.$el.classList.add("qform-valid_light");
        }
        if (!data.formStyleValidationSuccess.useDesign) {
          this.$form.$el.classList.remove("qform-valid_inside-left");
          this.$form.$el.classList.remove("qform-valid_inside-right");
          this.$form.$el.classList.remove("qform-valid_outside-left");
          this.$form.$el.classList.remove("qform-valid_outside-right");
          this.$form.$el.classList.remove("qform-valid_label");
          this.$form.$el.classList.remove("qform-valid_light");
        }
      }
      // Error
      if (data.formStyleError && typeof data.formStyleError.type !== "undefined") {
        if (data.formStyleError.type === 0) {
          if (typeof data.formStyleError.iconPositionInsideInput !== "undefined" && data.formStyleError.iconPositionInsideInput === 0) {
            this.$form.$el.classList.add("qform-error_inside-left");
          } else {
            this.$form.$el.classList.add("qform-error_inside-right");
          }
        } else if (data.formStyleError.type === 1) {
          if (typeof data.formStyleError.iconPositionOutsideInput !== "undefined" && data.formStyleError.iconPositionOutsideInput === 0) {
            this.$form.$el.classList.add("qform-error_outside-left");
          } else {
            this.$form.$el.classList.add("qform-error_outside-right");
          }
        } else if (data.formStyleError.type === 2) {
          this.$form.$el.classList.add("qform-error_label");
        } else if (data.formStyleError.type === 3) {
          this.$form.$el.classList.add("qform-error_light");
        }
        if (!data.formStyleError.useDesign) {
          this.$form.$el.classList.remove("qform-error_inside-left");
          this.$form.$el.classList.remove("qform-error_inside-right");
          this.$form.$el.classList.remove("qform-error_outside-left");
          this.$form.$el.classList.remove("qform-error_outside-right");
          this.$form.$el.classList.remove("qform-error_label");
          this.$form.$el.classList.remove("qform-error_light");
        }
      }
    }
  }
  setHintStyles() {
    const hintIcons = this.$form.$el.querySelectorAll(".qform-field_hint");
    for (let i = 0; i < hintIcons.length; i++) {
      const content = hintIcons[i].querySelector(".qform-field_hint_message > p");
      const message = hintIcons[i].querySelector(".qform-field_hint_message");
      hintIcons[i].addEventListener("mouseenter", () => {
        //если не хватает места между иконкой подсказки и верхней границей страницы для появления сообщения,
        //показываем его сбоку от значка
        const hintCoords = hintIcons[i].getBoundingClientRect();
        if (hintCoords.top < content.clientHeight + 5) {
          hintIcons[i].classList.add("qform-hint__under-sign");
        } else {
          hintIcons[i].classList.remove("qform-hint__under-sign");
        }
        if (document.documentElement.clientWidth - hintCoords.right < content.clientWidth + 5) {
          if (hintCoords.left < content.clientWidth + 5) {
            hintIcons[i].classList.add("qform-hint__centered");
          } else {
            hintIcons[i].classList.add("qform-hint__reverted");
          }
        } else {
          hintIcons[i].classList.remove("qform-hint__reverted");
          hintIcons[i].classList.remove("qform-hint__centered");
        }
        message.style.height = content.clientHeight + "px";
        message.style["box-shadow"] = "0px 0px 4px 0px #828282";
      });
      hintIcons[i].addEventListener("mouseleave", () => {
        message.style.removeProperty("height");
        message.style.removeProperty("box-shadow");
      });
    }
  }
  setGoogleFont() {
    if (this.useDesign) {
      this.fontCssRule = this.allStyle.formStyleText.font ? `'${this.allStyle.formStyleText.font.name}', sans-serif` : "inherit";
      this.$form.$el.style.fontFamily = this.fontCssRule;
      //если форма в модальном окне
      if (this.data.displayType === 1) {
        this.$btnModal.$el.style.fontFamily = this.fontCssRule;
        this.$modal.$el.style.fontFamily = this.fontCssRule;
      }
    }
  }
  setFormWidth() {
    let el = this.data.displayType === 1 ? this.$modal.$el : this.$el.$el;

    //если форма в контенте
    if (this.data.displayType === 0) {
      if (Number(this.formWidth) === 0) {
        el.style.width = "100%";
        el.style.maxWidth = "100%";
      } else {
        el.style.width = "100%";
        el.style.maxWidth = `${this.data.width}px`;
        el.style.margin = "0 auto";
      }
      //если форма в модальном окне
    } else {
      if (Number(this.formWidth) === 0) {
        el.style.width = "auto";
        el.style.maxWidth = "100%";
      } else {
        el.style.width = "calc(100vw - 40px)";
        el.style.maxWidth = `${this.data.width}px`;
        el.style.margin = "20px auto";
        el.style.boxSizing = "border-box";
      }
    }
    //в выражении calc(100vw - 40px) 40px - это 20px * 2 - боковые маржины модального окна
  }
  getOptions(arrComponentsOptions) {
    if (!this.allOptions) {
      if (arrComponentsOptions.length > 0) {
        this.Transporter.post(`https://${this.options.server_host}${this.options.options_controller}`, {
          body: {
            domain: this.options.domain,
            formId: this.id,
            fields: JSON.stringify(arrComponentsOptions)
          },
          options: {
            method: "POST",
            decode: false
          },
          callback: this.setOptions = this.setOptions.bind(this)
        });
      }
    } else {
      this.setOptions(this.allOptions);
    }
  }
  setOptions(data) {
    this.components.forEach(component => {
      if (typeof component.setOption === "function") {
        const fieldId = component.options.id;
        if (data[component.typeId]) {
          component.setOption(data[component.typeId].filter(o => o.formFieldId === fieldId));
        }
      }
    });
  }
  validForm() {
    let valid = this.settings.data.active;
    this.components.forEach(component => {
      if (component.validation && !component.validation()) {
        // // console.log("Валидация не пройдена!!!");
        valid = false;
      }
    });
    if (this.useRecaptcha === 1 && valid) {
      this.Emitter.emit("QForm:captchaShow", {});
    } else if (this.useRecaptcha === 0 && valid) {
      // <--lang_school
      if (window.hasOwnProperty("forcedRequiredFieldsRemains")) {
        window.forcedRequiredFieldsRemains = !window.forcedRequiredFieldsValidation();
        if (!window.forcedRequiredFieldsRemains) {
          this.Emitter.emit("Submit:sendForm", {});
        }
        // -->
      } else {
        this.Emitter.emit("Submit:sendForm", {});
      }
    }
  }
  reset() {
    this.components.forEach(component => {
      if (component.reset) {
        component.reset();
      }
    });
  }
  setRootMessage(data) {
    let $el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.data.displayType === 0 ? this.$el.$el : this.$modal.$el;
    const sendMessageEl = document.createElement("div");
    sendMessageEl.classList.add("qform-after-send-msg");
    this.useDesign && sendMessageEl.classList.add(data.error ? "qform__error-send-msg" : "qform__success-send-msg");
    sendMessageEl.style.cssText = `
            max-width: 100%;
        font-family: ${this.fontCssRule || "inherit"};
        ${this.allStyle.formStyleCommon.theme ? "color: #fff;" : ""}
        ${this.formWidth ? `width: ${this.formWidth + "px"}` : ""}
        `;
    sendMessageEl.innerHTML = `
     <div class="message_from_server" style="${this.allStyle.formStyleCommon.theme ? "background: #4E4A4A;" : ""}">
            <p>
                ${data.success || data.error}
            </p>
        </div>
     `;
    $el.appendChild(sendMessageEl);
    const storedData = JSON.parse(localStorage.getItem(this.options.formId));
    if (storedData) {
      localStorage.removeItem(this.options.formId);
    }
    if (this.data?.displayType === 0) {
      $el.style.background = "none";
    } else if (this.data?.displayType === 1) {
      this.$modal.append(this.getModalCloseBtn());
      this.btnModalComponent.initModalCloseBtn();
    }
  }
  async setMassageSend(data) {
    const elemToInsert = this.data.displayType === 0 ? this.$el.$el : this.$modal.$el;
    elemToInsert.innerHTML = "";
    this.setRootMessage(data, elemToInsert);
    // Результаты полей "Голосование"
    if ("vote" in data && Object.keys(data.vote).length) {
      setVoteResult(elemToInsert, {
        results: data.vote
      }, this.data);
    }
    // Кнопка "Заполнить снова"
    if (this.data.showAgainButton) {
      const {
        setShowAgainButton
      } = await import(/* webpackChunkName: "ShowAgainButton" */
      "~/modules/components/ShowAgainButton/ShowAgainButton.component");
      setShowAgainButton(elemToInsert, this.messages.fillInAgain, {
        ...this.data.style.formStyleSubmitButton,
        ...this.data.style.formStyleCommon
      });
    }
    if (data.javascript) {
      if (data.javascript.extra) {
        try {
          eval(data.javascript.extra);
        } catch (e) {
          console.error("Ошибка в коде Javascript-события", e);
        }
      }
      // console.log(`ym --> ${typeof ym}`);
      if (typeof ym === "function" && data.javascript.yaCounter && data.javascript.yaTarget) {
        try {
          ym(+data.javascript.yaCounter, "reachGoal", data.javascript.yaTarget);
        } catch (e) {
          console.error("Yandex metrika is not connected or connection is incorrect", e);
        }
      } else {
        if (data.javascript.yaCounter && data.javascript.yaTarget) {
          try {
            window[`yaCounter${+data.javascript.yaCounter}`].reachGoal(data.javascript.yaTarget);
          } catch (e) {
            console.error("Yandex metrika is not connected or connection is incorrect", e);
          }
        }
      }
      if (typeof gtag === "function" && data.javascript.gaAction && data.javascript.gaLabel) {
        try {
          gtag("event", data.javascript.gaAction, {
            formName: data.javascript.gaLabel,
            formURL: window.location.host
          });
        } catch (e) {
          console.error("Google Analytics is not connected or connection is incorrect", e);
        }
      }
      reachVkGoal(data);
    }
  }
  getResponse(data) {
    this.Emitter.emit("Submit:disabledBtn", false, false);
    this.Emitter.emit("Submit:loading", false);
    if (data && data.success) {
      this.$form.$el.reset();
      this.reset();
      this.setMassageSend(data);
      this.dispatchCustomEvent("send");
      this.emitterFormWidget.emit(`form_${this.id}_send`);
      //показываем виджет, если он указан
      if (data.videowidgetId) {
        this.widgetId = data.videowidgetId;
        try {
          if (!window.players[this.widgetId].isDisposed()) {
            window.players[this.widgetId].dispose();
          }
        } catch (e) {

        } finally {
          this.showWidget();
        }
      }
    } else if (data && data.error) {
      const elemToInsert = this.data.displayType === 0 ? this.$el.$el : this.$modal.$el;
      elemToInsert.innerHTML = "";
      this.setRootMessage(data, elemToInsert);
    }
  }
  async sendForm() {
    let captchaToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    this.Emitter.emit("Submit:disabledBtn", true, true);
    this.Emitter.emit("Submit:loading", true);
    let data;
    const proxyData = this.Proxy.getData();
    data = {
      ...proxyData
    };
    data.gRecaptchaResponse = captchaToken.token || "";
    data.uuid = this.uuID;
    if (!!cookie.get("_ym_uid")) {
      data._ym_uid = cookie.get("_ym_uid");
    }
    if (!!cookie.get("ym_counter")) {
      data.ym_counter = cookie.get("ym_counter");
    }
    if (cookie.get("roistat_visit")) {
      data.roistatVisit = cookie.get("roistat_visit");
    }
    data.formId = this.id;
    data.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let crypt = new JSEncrypt();
    crypt.default_key_size = 515;
    crypt.setPublicKey(this.publicKey);
    let timeSTR = "" + Math.floor(new Date().getTime() / 1000);
    crypt.encrypt(timeSTR);
    data.verificationCode = crypt.encrypt(timeSTR);
    data.domain = this.domain;
    data.blockId = this.blockId || 0;
    data.siteSource = location.origin;
    data.pageSource = location.pathname + location.search + location.hash;

    // TODO: написать нормальный метод подготовки конфига
    // TODO: базовый класс для quiz & form
    data.userAgent = navigator.userAgent;
    data.os = navigator?.userAgentData?.platform || navigator?.platform || "unknown";
    data.deviceType = device.type();
    let fields = [];
    this.components.forEach(component => {
      if (component.getValue) {
        const dataField = component.getValue();
        if (dataField) {
          fields.push(dataField);
        }
      }
    });
    data.fields = JSON.stringify(fields);
    data.fillTime = Math.round(new Date(Date.now() - this.endInitForm || 0) / 1000);
    data.advAgreement = this.isAdviseCheckboxChecked;
    data.sessionId = cookie.get("session_id");
    data.qformUid = cookie.get("qform_uniq_user_id");
    // if (process.env.NODE_ENV === "development") {
    // }
    if (window.QFORM_FORM_PASSWORDS?.[this.id]) {
      data.password = window.QFORM_FORM_PASSWORDS[this.id];
    }
    if (cookie.get("qg_token")) {
      if (!window.QFormGlobalID?.checkExpToken(cookie.get("qg_token"))) {
        try {
          await window.QFormGlobalID?.refreshToken();
        } catch (e) {}
      }
      data.qformGlobalUserToken = cookie.get("qg_token");
    }
    this.Transporter.post(`https://${this.options.server_host}${this.options.send_controller}`, {
      body: data,
      options: {
        method: "POST",
        decode: false
      },
      callback: response => this.getResponse(response),
      callbackError: err => {
        this.Emitter.emit("Submit:disabledBtn", false, false);
        this.Emitter.emit("Submit:loading", false);
        if (err.readyState === 4 && err.response) {
          const message = JSON.parse(err.response);
          this.setRootMessage({
            error: message.recaptcha || message.error
          });
        }
      }
    });
  }
  checkStatusValid() {
    let valid = this.settings.data.active;
    this.components.forEach(component => {
      if (component.validation && !component.validation(false)) {
        valid = false;
      }
    });
    this.Emitter.emit("Submit:addDisabledStyleBtn", !valid);
  }
  onloadCaptcha() {
    this.Emitter.emit("QForm:onloadCaptcha", {});
  }
  initFieldHook() {
    this.countInitComponents++;
    //когда все компоненты будут проинициализированиы, отправляем статистику на сервер
    if (this.countInitComponents === this.components.length) {
      this.endInitForm = parseInt(new Date().getTime());
      this.emitterStatistics.emit(`${this.id}:fullTime`, {
        id: this.id,
        time: this.endInitForm
      });
      this.emitterStatistics.emit(`${this.id}:requestStatistic`, {
        id: this.id
      });
    }
  }
  async loadModule() {
    this.Transporter = await import(/* webpackChunkName: "transporter" */
    "../core/transporter").then(data => {
      return data.transporter;
    });
    this.$ = await import(/* webpackChunkName: "dom" */
    "../core/dom").then(data => {
      return data.$;
    });
    const Emitter = await import(/* webpackChunkName: "Emitter" */
    "../core/Emitter").then(data => {
      return data.Emitter;
    });
    this.BtnModalComponent = await import(/* webpackChunkName: "BtnModalComponent" */
    "../components/btnModal/btnModal.component").then(data => {
      return data.BtnModalComponent;
    });
    this.$el = this.$(this.selector);
    this.Emitter = new Emitter();
    let arrFieldId = [];
    this.fields.forEach(field => {
      arrFieldId.push(field.typeId);
    });
    this.TYPE_COMPONENTS = await this.getInstanceComponent(arrFieldId);
  }
  async getInstanceComponent(arrFieldId) {
    let instanceList = COMPONENTS;
    let instance = {};
    for (let i = 0; i < arrFieldId.length; i++) {
      if (instanceList[arrFieldId[i]]) {
        instance[arrFieldId[i]] = await instanceList[arrFieldId[i]]();
      }
    }
    instance.AgreementComponent = await instanceList.AgreementComponent();
    instance.CaptchaComponent = await instanceList.CaptchaComponent();
    return instance;
  }
  dispatchCustomEvent(eventName) {
    const initEvent = new Event(`qform_${this.id}_${eventName}`);
    this.$el.$el.dispatchEvent(initEvent);
  }
  async render() {
    await this.loadModule();
    // // console.log('loadModule', this.TYPE_COMPONENTS)
    await this.getComponent();
    this.Emitter.subscribe("Submit:validForm", this.validForm.bind(this));
    this.Emitter.subscribe("Submit:sendForm", this.sendForm.bind(this));
    this.Emitter.subscribe("Change:field", this.checkStatusValid.bind(this));
    this.Emitter.subscribe("adviseCheckboxChanged", checked => this.isAdviseCheckboxChecked = checked);
    this.emitterGlob.subscribe("Organizer:onloadCaptcha", this.onloadCaptcha.bind(this));
    this.Emitter.subscribe("initField", this.initFieldHook.bind(this));
    this.startTimeRender = parseInt(new Date().getTime());
    this.$el.clear();
    //если форма не в модальном окне, то вставляем контейнер ограничений перед самой формой
    if (this.data.displayType !== 1) {
      (this.settings.data.hasTimeLimit || this.settings.data.hasAmountLimit) && this.$el.append(Restrictions.getRestrictionsFormWrapper(this.settings.data));
    }
    this.$el.append(await this.getRoot());
    this.setGoogleFont();
    this.setFormWidth();
    //если форма не в модальном окне
    if (this.data.displayType !== 1) {
      //добавляем изображение к форме
      if (this.formPictureSrc) {
        if (this.device !== "mobile" || this.device === "mobile" && this.formPictureShowOnMobile) {
          this.addFormPicture();
        }
      }
    }
    this.endTimeRender = parseInt(new Date().getTime());
    this.emitterStatistics.emit(`${this.id}:buildTime`, {
      id: this.id,
      time: this.endTimeRender - this.startTimeRender
    });
    this.startInitForm = parseInt(new Date().getTime());
    this.components.forEach(component => {
      component.init({
        disable: !this.settings.data.active
      });
      component.Emitter.subscribe("Change:field", () => {
        if (component.typeId) {
          // console.log(e)
        }
      });
    });
    this.btnModalComponent ? await this.btnModalComponent.init() : null;

    // < Применение options
    this.getOptions(this.arrComponentsOptions);
    // </ Применение options
    // < Применение стилей css
    if (this.formStyle) {
      this.getStyle();
    } else {
      let arrClass = this.$form.$el.classList.value.split(" ");
      arrClass.forEach(nameClass => {
        this.$form.$el.classList.remove(nameClass);
      });
    }
    this.$form.$el.classList.toggle("--qform-inactive", !this.settings.data.active);
    //убираем прелоадеры
    document.querySelectorAll(`#${this.id}_loader_root`).forEach(el => el.remove());
    this.setFormPictureHeight();
    this.emitterFormWidget.emit(`form_${this.id}_init`);
    this.dispatchCustomEvent("init");
    //TODO: временная мера для возврата кнопки в элемент с согласием на обработку перс. данных
    if (!this.settings.inWidget) {
      const submitBoxId = `${this.data.submitButton.name}_${this.data.formID}_${this.settings.options.formIndex}_submit-box`;
      const agreementBoxId = `${this.data.submitButton.name}_${this.data.formID}_${this.settings.options.formIndex}_agreement-wrapper`;
      const submitBox = document.querySelector(`#${submitBoxId}`);
      const agreementBox = document.querySelector(`#${agreementBoxId}`);
      agreementBox?.classList.remove("qform-field__submit");
      const submitRow = submitBox.parentElement.parentElement;
      agreementBox?.append(submitBox);
      submitRow.remove();
    }
  }
  destroy() {
    this.components.forEach(component => component.destroy());
  }
  async showWidget() {
    const widgetsGenerator = await import("../videoWidget/videoWidgetsGenerator").then(module => new module.VideoWidgetsGenerator(this.options, this.domain, this.device, this.startTime));
    await widgetsGenerator.init();
    widgetsGenerator.formDisplayType = this.data.displayType;

    //закрываем все виджеты, не принадлежащие форме, кроме тех, которые имеют тип отображения в теле страницы,
    widgetsGenerator.freeWidgets?.forEach(widget => {
      if (widget.type_display !== 1) {
        widget.closeWidget({
          forcedClose: true
        });
        try {
          if (!window.players[widget.id].isDisposed()) {
            window.players[widget.id].dispose();
          }
        } catch (e) {

        }
      }
    });
    if (!document.querySelector(`div[data-widget=${this.widgetId}]`)) {
      const widgetNode = document.createElement("div");
      widgetNode.setAttribute("data-widget", this.widgetId);
      document.body.append(widgetNode);
    }
    await widgetsGenerator._renderWidgets([this.widgetId]);
  }
}